import { useApiCall } from "@jane/lib/src/api";
import { LearnModule } from "@jane/lib/src/api/repositories/learn-repository";
import { Input } from "@jane/lib/src/components/form/Input";
import { Select } from "@jane/lib/src/components/form/Select";
import {FC, useState} from "react";
import {config} from "../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const AddLearnComponentModal: FC<{onFinished: () => void, module: LearnModule, moduleId: string}> = (props) => {
  const {learn} = useApiCall(config)
  const [name, setName] = useState('')
  const [chapter, setChapter] = useState('-')
  const save = async () => {
    await learn.addComponent(props.moduleId, name, chapter === '-' ? null : chapter)
    props.onFinished()
  }
  return <div className={"flex flex-col space-y-3"}>
    <Input type={'text'} label={'Naam'} value={name} onChange={setName} />
    <Select label={'Hoofdstuk'} options={{'-': 'Geen', ...Object.fromEntries(props.module.chapters.map((chapter,i) => [chapter, `${i+1}. ${chapter}`]))}} value={chapter} onChange={setChapter} />
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </div>
}